export const rootDepartmentsStoreKey = 'rootDepartments';
